import { lazy } from "react";
import type { RouteObject } from "react-router";

const PurchaseIndex = lazy(() => import("./pages/page"));
const Items = lazy(() => import("./pages/items/page"));

// Purchase Orders
const PurchaseOrders = lazy(() => import("./pages/purchase-orders/page"));
const PurchaseOrderNew = lazy(() => import("./pages/purchase-orders/new/page"));
const PurchaseOrderDetail = lazy(() => import("./pages/purchase-orders/[id]/page"));

// Suppliers
const Suppliers = lazy(() => import("./pages/suppliers/page"));
const SupplierDetail = lazy(() => import("./pages/suppliers/[id]/page"));

// Procurement Control
const LandedCosts = lazy(() => import("./pages/landed-costs/page"));
const ProcurementVariance = lazy(() => import("./pages/reports/procurement-variance/page"));

export const purchaseRoutes: RouteObject[] = [
  { index: true, Component: PurchaseIndex },
  { path: "dashboard", Component: PurchaseIndex },
  { path: "items", Component: Items },

  // Purchase Orders
  { path: "purchase-orders", Component: PurchaseOrders },
  { path: "purchase-orders/new", Component: PurchaseOrderNew },
  { path: "purchase-orders/:id", Component: PurchaseOrderDetail },

  // Suppliers
  { path: "suppliers", Component: Suppliers },
  { path: "suppliers/:id", Component: SupplierDetail },

  // Procurement Control
  { path: "landed-costs", Component: LandedCosts },
  { path: "reports/procurement-variance", Component: ProcurementVariance },
];
